import React from "react";
import { Tabs } from "./hiringCompany.types";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const RecruiterHiringCompany: React.FC = () => {
  const { pathname } = useLocation();
  const activeTab = pathname?.toLowerCase()?.replace("/hiring-company/", "");
  const navigate = useNavigate();

  return (
    <div className="flex flex-col rounded-lg bg-white w-full flex-grow p-6">
      <div className="flex gap-10 border-b w-[100%] py-2">
        <button
          className={`text-[#BABABA] leading-5 text-xs  border-b  ${
            activeTab ===
            Tabs.PartnerCompanies?.replaceAll(" ", "-")?.toLowerCase()
              ? "border-b-primary font-medium text-charcoal"
              : "border-b-white font-normal"
          }`}
          onClick={() =>
            navigate(
              `/hiring-company/${Tabs.PartnerCompanies?.replaceAll(
                " ",
                "-"
              )?.toLowerCase()}`
            )
          }
        >
          {Tabs?.PartnerCompanies}
        </button>
        <button
          className={`text-[#BABABA]  leading-5 text-xs border-b ${
            activeTab ===
            Tabs.SearchHiringCompanies?.replaceAll(" ", "-")?.toLowerCase()
              ? "border-b-primary font-medium text-charcoal"
              : "border-b-white font-normal"
          }`}
          onClick={() =>
            navigate(
              `/hiring-company/${Tabs.SearchHiringCompanies?.replaceAll(
                " ",
                "-"
              )?.toLowerCase()}`
            )
          }
        >
          {Tabs?.SearchHiringCompanies}
        </button>
      </div>
      <Outlet />
    </div>
  );
};

export default RecruiterHiringCompany;
